import { CopyIconWithText } from "@/components/CopyIconWithText";
import { DialogLocal } from "@/components/Dialog";
import { Icon } from "@/components/Icon";
import { SecurityPwdPopup } from "@/components/SecurityPwdPopup";
import SubLayout from "@/components/SubLayout";
import { Button, Image } from "antd-mobile";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBindSetup } from "./bindLogic";
import styles from "./index.module.scss";
import { PasswordKit } from "@/components/PasswordKit";

const MODAL_TYPE_CONFIRM = "confirm";
const MODAL_TYPE_BIND = "bind";

export function PageBindGoogleAuth() {
  const navigate = useNavigate();

  const store = useBindSetup();
  const [modal, setModal] = useState<{ visible: boolean; data: string }>({
    visible: false,
    data: "",
  });

  const onModalSubmit = (value: string) => {
    if (modal.data === MODAL_TYPE_CONFIRM) {
      setModal({ visible: false, data: "" });
      store.fetchBindGoogleAuthenticator(value);
    }
    if (modal.data === MODAL_TYPE_BIND) {
      setModal({ visible: false, data: "" });
      store.fetchCheckBindGoogleAuthenticator({
        safeCode: value,
        secret: store.googleCode.secret,
      });
    }
  };

  const onModalClose = () => {
    if (modal.data === MODAL_TYPE_CONFIRM) {
      setModal({ visible: false, data: "" });
      return navigate(-1);
    }
    if (modal.data === MODAL_TYPE_BIND) {
      setModal({ visible: false, data: "" });
    }
  };

  const onSubmit = () => {
    DialogLocal({
      title: "请输入动态验证码以验证身份",
      content:
        "绑定后，使用钱包充值游戏平台，卖币确认转币 需要通过谷歌身份验证器验证",
      onConfirm: () => {
        setModal({ visible: true, data: MODAL_TYPE_BIND });
      },
    });
  };
  useEffect(() => {
    DialogLocal({
      title: "请输入资金密码",
      content: "为了您的账户安全，绑定谷歌验证器需要验证资金密码",
      confirmText: "确认",
      onConfirm: () => {
        setModal({ visible: true, data: MODAL_TYPE_CONFIRM });
      },
    });
  }, []);

  return (
    <SubLayout
      title={"绑定谷歌认证器"}
      footer={
        <Button className={"common-submit-button"} onClick={() => {onSubmit()}}>
          确定
        </Button>
      }
    >
      <section className={styles.scan}>
        {store.googleCode?.qrCodeUrl ? (
          <Image src={store.googleCode?.qrCodeUrl} />
        ) : null}
      </section>
      <section style={{ textAlign: "center" }}>
        {store.googleCode?.secret ? (
          <CopyIconWithText text={store.googleCode.secret} />
        ) : null}
      </section>

      <section className={styles.tip}>
        使用Google Authenticator 扫码或输入设置密钥以绑定
      </section>

      <section className={styles.input_types}>
        <div className={styles.input_type_space}></div>
        <div className={styles.input_type}>
          <Icon name={"scan"} size={"28px"} /> 扫码
        </div>

        <div className={styles.input_tip}>或</div>
        <div className={styles.input_type}>
          <Icon name={"key"} size={"28px"} /> 密钥
        </div>
        <div className={styles.input_type_space}></div>
      </section>
      <PasswordKit />
      <SecurityPwdPopup
        visible={modal.visible}
        onSubmit={onModalSubmit}
        onClose={onModalClose}
      />
    </SubLayout>
  );
}
